import React, { useState } from "react";
import { saveB2BClient, deleteB2BClient } from "../../data/b2bClients";

export default function B2BClientsTab({ clients, setClients }) {
  const [formData, setFormData] = useState({ 
    id: null, companyName: "", contactName: "", siret: "", tva: "", address: "", deliveryAddress: "", phone: "", email: "" 
  });
  const [isEditing, setIsEditing] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.companyName) return;
    const saved = await saveB2BClient(formData);
    
    // Update local state
    if (isEditing) {
      setClients(clients.map(c => c.id === saved.id ? saved : c));
    } else {
      setClients([...clients, saved]);
    }

    setFormData({ id: null, companyName: "", contactName: "", siret: "", tva: "", address: "", deliveryAddress: "", phone: "", email: "" });
    setIsEditing(false);
  };

  const handleEdit = (client) => {
    setFormData(client);
    setIsEditing(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer ce client ?")) return;
    await deleteB2BClient(id);
    setClients(clients.filter(c => c.id !== id));
  };

  return (
    <div className="mt-4">
      <div className="card shadow-sm mb-4">
        <div className="card-header bg-white">
          <h5 className="mb-0">{isEditing ? "Modifier Client Pro" : "Nouveau Client Pro"}</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Nom de l'établissement *</label>
                <input type="text" className="form-control" value={formData.companyName} onChange={e => setFormData({...formData, companyName: e.target.value})} required />
              </div>
              <div className="col-md-6">
                <label className="form-label">Contact (Nom, Prénom)</label>
                <input type="text" className="form-control" value={formData.contactName} onChange={e => setFormData({...formData, contactName: e.target.value})} />
              </div>
              <div className="col-md-6">
                <label className="form-label">SIRET</label>
                <input type="text" className="form-control" value={formData.siret} onChange={e => setFormData({...formData, siret: e.target.value})} />
              </div>
              <div className="col-md-6">
                <label className="form-label">N° TVA</label>
                <input type="text" className="form-control" value={formData.tva} onChange={e => setFormData({...formData, tva: e.target.value})} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Adresse de facturation</label>
                <input type="text" className="form-control" value={formData.address} onChange={e => setFormData({...formData, address: e.target.value})} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Adresse de livraison (si différente)</label>
                <input type="text" className="form-control" value={formData.deliveryAddress} onChange={e => setFormData({...formData, deliveryAddress: e.target.value})} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Téléphone</label>
                <input type="text" className="form-control" value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Email</label>
                <input type="email" className="form-control" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} />
              </div>
              <div className="col-12 text-end">
                {isEditing && (
                  <button type="button" className="btn btn-secondary me-2" onClick={() => {
                    setIsEditing(false);
                    setFormData({ id: null, companyName: "", contactName: "", siret: "", tva: "", address: "", deliveryAddress: "", phone: "", email: "" });
                  }}>Annuler</button>
                )}
                <button type="submit" className="btn btn-primary">{isEditing ? "Enregistrer les modifications" : "Ajouter le client"}</button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th>Établissement</th>
              <th>Contact</th>
              <th>Email</th>
              <th>Téléphone</th>
              <th>Ville / Adresse</th>
              <th className="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            {(clients || []).map(client => (
              <tr key={client.id}>
                <td><strong>{client.companyName}</strong></td>
                <td>{client.contactName}</td>
                <td>{client.email}</td>
                <td>{client.phone}</td>
                <td>{client.address}</td>
                <td className="text-end">
                  <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => handleEdit(client)}>
                    <i className="fas fa-edit"></i>
                  </button>
                  <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(client.id)}>
                    <i className="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))}
            {(!clients || clients.length === 0) && (
              <tr>
                <td colSpan="6" className="text-center py-4 text-muted">Aucun client pro trouvé.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

